import { jsx as n, jsxs as I } from "react/jsx-runtime";
import p from "react";
import { c as r } from "./index.CWkFp9WS.js";
import { O as G } from "./ODSIcon.DjL6Q3o4.js";
import { u as O } from "./ODSGlobalHeader.utils.CBEpEpr3.js";
import '../assets/ODSGlobalHeaderIconButton.css';const B = (e) => {
  const { label: a, icon: o, badge: l, size: s } = e;
  return /* @__PURE__ */ I(
    "span",
    {
      className: r(
        "ODSGlobalHeaderIconButton-Container",
        `ODSGlobalHeaderIconButton-Container--${s}`
      ),
      children: [
        /* @__PURE__ */ I("span", { className: "ODSGlobalHeaderIconButton-Icon", "aria-hidden": "true", children: [
          l,
          typeof o == "string" ? /* @__PURE__ */ n(G, { name: o, size: 24, decorative: !0 }) : o
        ] }),
        /* @__PURE__ */ n("span", { className: "ODSGlobalHeaderIconButton-Label", children: a })
      ]
    }
  );
}, H = p.forwardRef((e, a) => {
  const {
    label: o,
    selected: l,
    icon: s,
    size: c,
    badge: d,
    className: i,
    ...u
  } = e, { viewport: m } = O(), t = c ?? D(m), b = S(d, t);
  return /* @__PURE__ */ n(
    "button",
    {
      ref: a,
      className: r("ODSGlobalHeaderIconButton", i, {
        "ODSGlobalHeaderIconButton--selected": l,
        [`ODSGlobalHeaderIconButton--${t}`]: !0
      }),
      ...u,
      children: /* @__PURE__ */ n(B, { label: o, icon: s, badge: b, size: t })
    }
  );
});
H.displayName = "ODSGlobalHeaderIconButton";
const f = p.forwardRef((e, a) => {
  const {
    label: o,
    selected: l,
    icon: s,
    size: c,
    badge: d,
    className: i,
    ...u
  } = e, { viewport: m } = O(), t = c ?? D(m), b = S(d, t);
  return /* @__PURE__ */ n(
    "a",
    {
      ref: a,
      className: r("ODSGlobalHeaderIconButton", i, {
        "ODSGlobalHeaderIconButton--selected": l,
        [`ODSGlobalHeaderIconButton--${t}`]: !0
      }),
      ...u,
      children: /* @__PURE__ */ n(B, { label: o, icon: s, badge: b, size: t })
    }
  );
});
f.displayName = "ODSGlobalHeaderIconLink";
function S(e, a) {
  return e ? p.cloneElement(e, {
    size: "small",
    as: "span",
    ...e.props,
    className: r(
      e.props.className,
      "ODSGlobalHeaderIconButton-IconBadge",
      `ODSGlobalHeaderIconButton-IconBadge--${a}`
    )
  }) : void 0;
}
function D(e) {
  switch (e) {
    case "small":
    case "medium":
      return "small";
    default:
      return "large";
  }
}
export {
  H as O,
  f as a
};
//# sourceMappingURL=ODSGlobalHeaderIconButton.g4tUUKwo.js.map
